import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { setting } from '../../../../setting';


@Injectable({
  providedIn: 'root'
})
export class FormOfflineService {

  private apiBookingUrl = setting.apiBookingUrl;

  constructor(private http: HttpClient) { }

  createRequestOffline(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiBookingUrl}offline-requests`, payload);
  }

  /**
   * Reabre una solicitud offline existente con payload { status: 1, product?: {...} }.
   * Pending Laravel validation extension — see BackOffice TODO at
   * Booking-BackOffice/.../request-offline-details.component.ts:159-161.
   */
  updateRequestOffline(detailId: number, payload: any): Observable<any> {
    return this.http.put<any>(
      `${this.apiBookingUrl}offline-requests/${detailId}`,
      payload
    );
  }

  /**
   * Obtiene los itineraries de un agente para el selector de files existentes.
   * Endpoint: GET itineraries?page={page}&agent_id={agentId}&per_page={perPage}&search={term}
   *
   * `search` filtra por title del itinerary o por nombre/apellido de clientes asociados.
   * Si no se pasa search, devuelve los últimos archivos (orden por latest).
   */
  getItinerariesForAgent(
    agentId: number,
    page = 1,
    perPage = 100,
    search: string = ''
  ): Observable<any> {
    let url = `${this.apiBookingUrl}itineraries?page=${page}&agent_id=${agentId}&per_page=${perPage}`;
    if (search && search.trim() !== '') {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    return this.http.get<any>(url);
  }
}
